/**
 * Image URL helper. Product photos on cdn.luxsova.com are served through the
 * droplet's nginx resizer at /img/<width>/<path> (cached on disk and at the
 * Cloudflare edge), so phones and small tiles download a few KB instead of the
 * full 1000px original. Other hosts (legacy cdn.luxmaart.com, Unsplash, …) and
 * non-JPG/PNG/WEBP files pass through unmodified.
 *
 * Allowed widths must match the location regex in the nginx config
 * (/etc/nginx/sites-available/luxsova): 200 | 400 | 600 | 900 | 1200.
 */
const RESIZE_HOSTS = ["cdn.luxsova.com"];
const SIZES = [200, 400, 600, 900, 1200];
const RESIZABLE = /\.(?:jpe?g|png|webp)$/i;

function parts(url) {
  try {
    const u = new URL(url, window.location.origin);
    if (!RESIZE_HOSTS.includes(u.hostname)) return null;
    if (!RESIZABLE.test(u.pathname)) return null;
    return u.pathname; // "/scraped/x/1-hq.jpg"
  } catch {
    return null;
  }
}

function rewrite(url, w) {
  const path = parts(url);
  return path ? `/img/${w}${path}` : url;
}

const pickWidth = (want) => SIZES.find((s) => s >= want) || SIZES[SIZES.length - 1];

export function imageUrl(src, width = 600) {
  if (!src) return src;
  return rewrite(src, pickWidth(width));
}

export function imageSrcSet(src) {
  if (!src || !parts(src)) return undefined;
  return SIZES.map((w) => `${rewrite(src, w)} ${w}w`).join(", ");
}

export const DEFAULT_SIZES_ATTR =
  "(min-width: 1280px) 22vw, (min-width: 768px) 32vw, 48vw";
